import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import { colorBlack, colorYellow } from '../../Global/global-styles'
import ResponsiveFont from '../ResponsiveFont/ResponsiveFont'
import icon from './aex_train.svg'

// A PureComponent
const NextDeparture = React.memo<{
    departureTime: string
    departureDay: string
    next?: string
    half: boolean
}>(({ departureTime, departureDay, next, half }) => {
    const [isMounted, setMountedState] = useState<boolean>(false)
    useEffect(() => setMountedState(true), []) // On componentDidMount

    if (!departureTime) {
        return null
    }

    return (
        <Wrapper $half={half} $mounted={isMounted}>
            <Time>
                <Icon>
                    <IconFile src={icon} />
                </Icon>
                <Text>
                    {next && (
                        <Unit>
                            <ResponsiveFont ratio={30}>{next}</ResponsiveFont>
                        </Unit>
                    )}
                    <Remaining>
                        <ResponsiveFont ratio={12}>{departureTime}</ResponsiveFont>
                    </Remaining>
                    <Unit>
                        <ResponsiveFont ratio={30}>{departureDay}</ResponsiveFont>
                    </Unit>
                </Text>
            </Time>
        </Wrapper>
    )
})

export default NextDeparture

const Icon = styled.div`
    height: 50%;
    display: flex;
    align-items: flex-end;
    justify-content: center;

    @media (orientation: portrait) {
        width: auto;
        padding-right: 5%;
    }

    @media (orientation: landscape) {
        height: 50%;
    }
`
const IconFile = styled.img`
    padding: 0;
    margin: 0 auto;
    max-width: 100%;
    max-height: 100%;
`
const Text = styled.div`
    margin-top: 2vh;
`
const Remaining = styled.div`
    font-family: TransferSans, 'Transfer Sans', sans-serif;
`
const Unit = styled.div`
    font-weight: bold;
    margin-top: -0.5vh;
`

interface WrapperProps {
    $half: boolean
    $mounted: boolean
}

const transformHelperLandscape = (props: WrapperProps) => {
    let startingPosition = props.$half ? 100 : 40
    let endingPosition = props.$half ? 40 : 0

    if (!props.$mounted) {
        return `translate(${startingPosition}vw, 0)`
    }

    return `translate(${endingPosition}vw, 0)`
}

const transformHelperPortrait = (props: WrapperProps) => {
    let startingPosition = props.$half ? 100 : 40
    let endingPosition = props.$half ? 40 : 0

    if (!props.$mounted) {
        return `translate(0, ${startingPosition}vh)`
    }

    return `translate(0, ${endingPosition}vh)`
}

const spaceFromEdge = 15
const Wrapper = styled.div<WrapperProps>`
    background: ${colorBlack};
    color: ${colorYellow};
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    transition: transform 1s;

    @media (orientation: landscape) {
        padding: ${spaceFromEdge + 7}vh ${spaceFromEdge}vh ${spaceFromEdge}vh;
        transform: ${(props: WrapperProps) => transformHelperLandscape(props)};
    }

    @media (orientation: portrait) {
        padding: ${spaceFromEdge + 7}vw ${spaceFromEdge}vw ${spaceFromEdge}vw;
        transform: ${(props: WrapperProps) => transformHelperPortrait(props)};
    }
`

const Time = styled.div`
    position: absolute;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    transition: transform 2s ease-in-out, left 2s ease-in-out, opacity 2s;

    @media (orientation: landscape) {
        top: ${spaceFromEdge + 7}vh;
        bottom: ${spaceFromEdge}vh;
        min-width: 150px;
        width: 30%;
    }

    @media (orientation: portrait) {
        top: ${spaceFromEdge - 2}vw;
        bottom: ${spaceFromEdge}vw;
        min-height: 150px;
        height: 30%;
    }
`
